module.exports = __webpack_public_path__ + "img/TOP BIANCA GONNA NEVE.9a73f157.jpg";